import React, { FC, useEffect, useState } from 'react';

import { ResourceMapping } from '@ariksa/inventory-core/api';
import { HStack } from '@chakra-ui/react';

import { StackedHeader } from 'components/DataDisplay';
import { BackIconButton } from 'components/DataEntry';
import { useActiveResourceContext } from 'containers/ActiveCloudResource/hooks/context/context';
import { useResourceType } from 'containers/App/hooks/useResourceType';

export interface Props {
  onBack?();
  isLoading?: boolean;
}

export const MetadataHeader: FC<Props> = props => {
  const {
    resourceInsight,
    resourceType,
    resourceDetails,
  } = useActiveResourceContext();
  const { data: insight } = resourceInsight;
  const { data: resource } = resourceDetails;
  const [type, setType] = useState<ResourceMapping>({} as ResourceMapping);
  const { getResourceType } = useResourceType();

  useEffect(() => {
    setType(getResourceType(resourceType) || ({} as ResourceMapping));
  }, [getResourceType, resourceType]);

  return (
    <HStack spacing={4} w="full">
      {props.onBack && (
        <BackIconButton
          aria-label="Back to previous resource"
          onClick={props.onBack}
        />
      )}
      <StackedHeader
        upper={
          insight?.name ||
          resource?.general?.name ||
          insight?.resource_id ||
          resource?.general?.resource_id
        }
        lower={`${insight?.native_display_name ?? type.cloud_native_name} / ${
          insight?.agnostic_display_name ?? type.cloud_agnostic_name
        }`}
        type={resourceType}
        isLoading={props?.isLoading ?? insight?.isLoading}
      />
    </HStack>
  );
};
